import { useEffect, useRef } from "react";
import { Application, Assets, Sprite } from "pixi.js";

import pvgLogoPng01 from "../../assets/pixies_vs_giants_logo_01.png";
import pvgLogoPng02 from "../../assets/pixies_vs_giants_logo_02.png";

import "./PVGLogo.css";

// HELPER FUNCTIONS //
function pickRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

// LOGO //
export default function PVGLogo({
    size = 200,
    tint = 0xcdcdcd,
    className = ""
}) {
    const pixiRef = useRef(null);

    useEffect(() => {
        let app;
        let restTimeoutId;
        let flickerIntervalId;
        let flickerTimeoutId;
        let isDestroyed = false;
        
        async function initPixi() {
            // const SOURCE_WIDTH = 1087;
            const SOURCE_MAX_WIDTH = 1476;
            const SOURCE_HEIGHT = 1000;

            const DISPLAY_HEIGHT = size;
            // const DISPLAY_WIDTH = SOURCE_WIDTH * (DISPLAY_HEIGHT / SOURCE_HEIGHT);
            const DISPLAY_WIDTH = SOURCE_MAX_WIDTH * (DISPLAY_HEIGHT / SOURCE_HEIGHT);
            const LOGO_SCALE = DISPLAY_HEIGHT / SOURCE_HEIGHT;

            app = new Application();

            await app.init({
                width: DISPLAY_WIDTH,
                height: DISPLAY_HEIGHT,
                backgroundAlpha: 0,
                antialias: true,
                resolution: 2,
                autoDensity: false
            });

            if (isDestroyed || !pixiRef.current) return;

            pixiRef.current.appendChild(app.canvas);

            // const texture = await Assets.load(pvgLogoPng01);
            const textures = await Promise.all([
                Assets.load(pvgLogoPng01),
                Assets.load(pvgLogoPng02)
            ]);

            if (isDestroyed) return;

            const sprite = new Sprite(textures[0]);

            sprite.anchor.set(0.5);
            sprite.scale.set(LOGO_SCALE);
            sprite.x = DISPLAY_WIDTH / 2;
            sprite.y = DISPLAY_HEIGHT / 2;
            sprite.tint = tint;

            app.stage.addChild(sprite);

            function startCycle() {
                const restTime = 3000 + Math.random() * 4000; // 3-7 SECONDS //

                restTimeoutId = setTimeout(() => {
                    flickerIntervalId = setInterval(() => {
                        sprite.texture = pickRandom(textures);
                    }, 90);

                    flickerTimeoutId = setTimeout(() => {
                        clearInterval(flickerIntervalId);
                        startCycle();
                    }, 1000);
                }, restTime);
            }

            startCycle();
        }

        initPixi();

        return () => {
            isDestroyed = true;

            clearTimeout(restTimeoutId);
            clearInterval(flickerIntervalId);
            clearTimeout(flickerTimeoutId);
            
            if (app) {
                app.destroy(true);
            }
        };

    }, [size, tint]);

    return (
        <div
            className={`pvg-logo ${className}`}
            ref={pixiRef}
        />
    );
}